import React, { Component } from "react";
import { Link, Redirect } from 'react-router-dom';
import queryString from 'query-string';

export default class Pagination extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
            currentPage : this.props.currentPage || 1,
            totalPages  : Number(this.props.totalPages) || 1
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        }, this.props.pageChange(Number(event.target.id)));
    }

    componentWillReceiveProps(nextProps){
        console.log('new props');
        this.setState({
            currentPage: Number(nextProps.currentPage) || 1,
            totalPages: Number(nextProps.totalPages) || 1
        })
    }
    
    render() {

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= this.state.totalPages ; i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            let active = ( number === this.state.currentPage) ? 'active' : '';
            return (

                <li key={ number }  className={"page-item " + active}>
                <Link to={ '?pag=' + number } id={ number } className="page-link" onClick={this.handleClick}> { number } </Link>
                </li>
                );
            });

        return (
            <div>
            <ul id="page-numbers" className="pagination pagination justify-content-center">
                {renderPageNumbers}
            </ul>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/admin/Pagination.jsx